import React from 'react';

import {
  Loading,
  useGetIdentity,
  usePermissions,
} from 'react-admin';

import {
  Grid,
  Typography,
  Box,
} from '@mui/material';

import RiskClassDistribution from './components/RiskClassDistribution';
import RuleTable from './components/RuleTable';
import PingAnalytics from './components/PingsAnalytics';
import RequestAnalytics from './components/RequestsAnalytics';
import ScoreDistribution from './components/ScoreDistribution';
import EntitiesDistribution from './components/EntitiesDistribution';
import CasesAnalytics from './components/CasesAnalytics';
import actions, { Actions } from '../../constants/actions';
import hasAccess from '../../utilities/hasAccess';

const Dashboard = () => {
  const { permissions } = usePermissions<Actions[]>();

  const { identity } = useGetIdentity();

  if (!identity) return <Loading />;

  return (
    <Grid container spacing={6}>
      <Grid size={12}>
        <Box display="flex" justifyContent="space-between">
          <Grid>
            <Typography variant="h3" gutterBottom>
              Analytics dashboard
            </Typography>
            <Typography variant="subtitle1">
              Welcome back
              {' '}
              {identity.displayName}
              !
              {' '}
              <span role="img" aria-label="Waving Hand Sign">
                👋
              </span>
            </Typography>
          </Grid>
        </Box>
      </Grid>
      {hasAccess(permissions, actions.CASE_GET) && (
        <Grid
          size={{
            xs: 12,
            md: 12,
            xl: 3,
          }}
        >
          <CasesAnalytics />
        </Grid>
      )}
      {hasAccess(permissions, actions.PING_GET) && (
        <Grid
          size={{
            xs: 12,
            md: 12,
            xl: 3,
          }}
        >
          <PingAnalytics />
        </Grid>
      )}
      {hasAccess(permissions, actions.REQUEST_GET) && (
        <Grid
          size={{
            xs: 12,
            md: 12,
            xl: 3,
          }}
        >
          <RequestAnalytics />
        </Grid>
      )}
      {hasAccess(permissions, actions.INDIVIDUAL_GET) && (
        <Grid
          size={{
            xs: 12,
            md: 12,
            xl: 3,
          }}
        >
          <EntitiesDistribution />
        </Grid>
      )}
      {hasAccess(permissions, actions.RISK_CLASS_GET) && (
        <Grid
          size={{
            xs: 12,
            md: 12,
            xl: 6,
          }}
        >
          <RiskClassDistribution />
        </Grid>
      )}
      {hasAccess(permissions, actions.SCORE_LIST) && (
        <Grid
          size={{
            xs: 12,
            md: 12,
            xl: 6,
          }}
        >
          <ScoreDistribution />
        </Grid>
      )}
      {hasAccess(permissions, actions.RULE_GET)
        && hasAccess(permissions, actions.RULE_VERSION_LIST) && (
        <Grid size={12}>
          <RuleTable />
        </Grid>
      )}
    </Grid>
  );
};
export default Dashboard;
